import { render, staticRenderFns } from "./integration-general.vue?vue&type=template&id=ec1d9cb4&scoped=true&"
import script from "./integration-general.vue?vue&type=script&lang=js&"
export * from "./integration-general.vue?vue&type=script&lang=js&"
import style0 from "./integration-general.vue?vue&type=style&index=0&id=ec1d9cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1d9cb4",
  null
  
)

export default component.exports